const state = {
  noteoptionList: [],
  addNoteOptionList: {},
  updateNoteOptionList: {},
  deleteNoteOptionList: {},
  sendNoteOptionPriority: {},
};

export default state;
